import _asyncToGenerator from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _ = !1;

var j = [],
    O = function O(n) {
  return new Promise(function (e, t) {
    if (typeof window > "u" || (window.storyblokRegisterEvent = function (r) {
      if (window.location === window.parent.location) {
        console.warn("You are not in Draft Mode or in the Visual Editor.");
        return;
      }

      _ ? r() : j.push(r);
    }, document.getElementById("storyblok-javascript-bridge"))) return;
    var s = document.createElement("script");
    s.async = !0, s.src = n, s.id = "storyblok-javascript-bridge", s.onerror = function (r) {
      return t(r);
    }, s.onload = function (r) {
      j.forEach(function (i) {
        return i();
      }), _ = !0, e(r);
    }, document.getElementsByTagName("head")[0].appendChild(s);
  });
};

var P = Object.defineProperty,
    I = function I(n, e, t) {
  return e in n ? P(n, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : n[e] = t;
},
    h = function h(n, e, t) {
  return I(n, typeof e != "symbol" ? e + "" : e, t), t;
};

function x(n) {
  return !(n !== n || n === 1 / 0 || n === -1 / 0);
}

function C(n, e, t) {
  if (!x(e)) throw new TypeError("Expected `limit` to be a finite number");
  if (!x(t)) throw new TypeError("Expected `interval` to be a finite number");
  var s = [];
  var r = [],
      i = 0;

  var o = function o() {
    i++;
    var a = setTimeout(function () {
      i--, s.length > 0 && o(), r = r.filter(function (u) {
        return u !== a;
      });
    }, t);
    r.indexOf(a) < 0 && r.push(a);
    var c = s.shift();
    c.resolve(n.apply(c.self, c.args));
  },
      l = function l() {
    for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
      a[_key] = arguments[_key];
    }

    var c = this;
    return new Promise(function (u, p) {
      s.push({
        resolve: u,
        reject: p,
        args: a,
        self: c
      }), i < e && o();
    });
  };

  return l.abort = function () {
    r.forEach(clearTimeout), r = [], s.forEach(function (a) {
      a.reject(function () {
        Error.call(this, "Throttled function aborted"), this.name = "AbortError";
      });
    }), s.length = 0;
  }, l;
}

var b = /*#__PURE__*/function () {
  function b() {
    var _this = this;

    _classCallCheck(this, b);

    h(this, "isCDNUrl", function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return e.indexOf("/cdn/") > -1;
    }), h(this, "getOptionsPage", function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      return _objectSpread(_objectSpread({}, e), {}, {
        per_page: t,
        page: s
      });
    }), h(this, "delay", function (e) {
      return new Promise(function (t) {
        return setTimeout(t, e);
      });
    }), h(this, "arrayFrom", function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 ? arguments[1] : undefined;
      return _toConsumableArray(Array(e)).map(t);
    }), h(this, "range", function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e;
      var s = Math.abs(t - e) || 0,
          r = e < t ? 1 : -1;
      return _this.arrayFrom(s, function (i, o) {
        return o * r + e;
      });
    }), h(this, "asyncMap", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", Promise.all(e.map(t)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()), h(this, "flatMap", function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var t = arguments.length > 1 ? arguments[1] : undefined;
      return e.map(t).reduce(function (s, r) {
        return [].concat(_toConsumableArray(s), _toConsumableArray(r));
      }, []);
    }), h(this, "escapeHTML", function (e) {
      var t = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      },
          s = /[&<>"']/g,
          r = RegExp(s.source);
      return e && r.test(e) ? e.replace(s, function (i) {
        return t[i];
      }) : e;
    });
  }
  /**
   * @method stringify
   * @param  {Object} params
   * @param  {String} prefix
   * @param  {Boolean} isArray
   * @return {String} Stringified object
   */


  _createClass(b, [{
    key: "stringify",
    value: function stringify(e, t, s) {
      var r = [];

      for (var i in e) {
        if (!Object.prototype.hasOwnProperty.call(e, i)) continue;
        var o = e[i],
            l = s ? "" : encodeURIComponent(i);
        var a = void 0;
        typeof o == "object" ? a = this.stringify(o, t ? t + encodeURIComponent("[" + l + "]") : l, Array.isArray(o)) : a = (t ? t + encodeURIComponent("[" + l + "]") : l) + "=" + encodeURIComponent(o), r.push(a);
      }

      return r.join("&");
    }
    /**
     * @method getRegionURL
     * @param  {String} regionCode region code, could be eu, us, cn, ap or ca
     * @return {String} The base URL of the region
     */

  }, {
    key: "getRegionURL",
    value: function getRegionURL(e) {
      var t = "api.storyblok.com",
          s = "api-us.storyblok.com",
          r = "app.storyblokchina.cn",
          i = "api-ap.storyblok.com",
          o = "api-ca.storyblok.com";

      switch (e) {
        case "us":
          return s;

        case "cn":
          return r;

        case "ap":
          return i;

        case "ca":
          return o;

        default:
          return t;
      }
    }
  }]);

  return b;
}();

var A = function A(n, e) {
  var t = {};

  for (var s in n) {
    var r = n[s];
    e.indexOf(s) > -1 && r !== null && (t[s] = r);
  }

  return t;
},
    N = function N(n) {
  return n === "email";
},
    L = function L() {
  return {
    singleTag: "hr"
  };
},
    M = function M() {
  return {
    tag: "blockquote"
  };
},
    z = function z() {
  return {
    tag: "ul"
  };
},
    U = function U(n) {
  return {
    tag: ["pre", {
      tag: "code",
      attrs: n.attrs
    }]
  };
},
    H = function H() {
  return {
    singleTag: "br"
  };
},
    q = function q(n) {
  return {
    tag: "h".concat(n.attrs.level)
  };
},
    F = function F(n) {
  return {
    singleTag: [{
      tag: "img",
      attrs: A(n.attrs, ["src", "alt", "title"])
    }]
  };
},
    V = function V() {
  return {
    tag: "li"
  };
},
    B = function B() {
  return {
    tag: "ol"
  };
},
    J = function J() {
  return {
    tag: "p"
  };
},
    D = function D(n) {
  return {
    tag: [{
      tag: "span",
      attrs: {
        "data-type": "emoji",
        "data-name": n.attrs.name,
        emoji: n.attrs.emoji
      }
    }]
  };
},
    Y = function Y() {
  return {
    tag: "b"
  };
},
    K = function K() {
  return {
    tag: "s"
  };
},
    W = function W() {
  return {
    tag: "u"
  };
},
    G = function G() {
  return {
    tag: "strong"
  };
},
    Q = function Q() {
  return {
    tag: "code"
  };
},
    X = function X() {
  return {
    tag: "i"
  };
},
    Z = function Z(n) {
  if (!n.attrs) return {
    tag: ""
  };

  var e = new b().escapeHTML,
      t = _objectSpread({}, n.attrs),
      _n$attrs$linktype = n.attrs.linktype,
      s = _n$attrs$linktype === void 0 ? "url" : _n$attrs$linktype;

  if (delete t.linktype, t.href && (t.href = e(n.attrs.href || "")), N(s) && (t.href = "mailto:".concat(t.href)), t.anchor && (t.href = "".concat(t.href, "#").concat(t.anchor), delete t.anchor), t.custom) {
    for (var r in t.custom) {
      t[r] = t.custom[r];
    }

    delete t.custom;
  }

  return {
    tag: [{
      tag: "a",
      attrs: t
    }]
  };
},
    ee = function ee(n) {
  return {
    tag: [{
      tag: "span",
      attrs: n.attrs
    }]
  };
},
    te = function te() {
  return {
    tag: "sub"
  };
},
    se = function se() {
  return {
    tag: "sup"
  };
},
    re = function re(n) {
  return {
    tag: [{
      tag: "span",
      attrs: n.attrs
    }]
  };
},
    ie = function ie(n) {
  var e;
  return (e = n.attrs) != null && e.color ? {
    tag: [{
      tag: "span",
      attrs: {
        style: "background-color:".concat(n.attrs.color, ";")
      }
    }]
  } : {
    tag: ""
  };
},
    oe = function oe(n) {
  var e;
  return (e = n.attrs) != null && e.color ? {
    tag: [{
      tag: "span",
      attrs: {
        style: "color:".concat(n.attrs.color)
      }
    }]
  } : {
    tag: ""
  };
},
    ne = {
  nodes: {
    horizontal_rule: L,
    blockquote: M,
    bullet_list: z,
    code_block: U,
    hard_break: H,
    heading: q,
    image: F,
    list_item: V,
    ordered_list: B,
    paragraph: J,
    emoji: D
  },
  marks: {
    bold: Y,
    strike: K,
    underline: W,
    strong: G,
    code: Q,
    italic: X,
    link: Z,
    styled: ee,
    subscript: te,
    superscript: se,
    anchor: re,
    highlight: ie,
    textStyle: oe
  }
},
    ae = function ae(n) {
  var e = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  },
      t = /[&<>"']/g,
      s = RegExp(t.source);
  return n && s.test(n) ? n.replace(t, function (r) {
    return e[r];
  }) : n;
};

var v = /*#__PURE__*/function () {
  function v(e) {
    _classCallCheck(this, v);

    h(this, "marks"), h(this, "nodes"), e || (e = ne), this.marks = e.marks || [], this.nodes = e.nodes || [];
  }

  _createClass(v, [{
    key: "addNode",
    value: function addNode(e, t) {
      this.nodes[e] = t;
    }
  }, {
    key: "addMark",
    value: function addMark(e, t) {
      this.marks[e] = t;
    }
  }, {
    key: "render",
    value: function render(e) {
      var _this2 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        optimizeImages: !1
      };

      if (e && e.content && Array.isArray(e.content)) {
        var s = "";
        return e.content.forEach(function (r) {
          s += _this2.renderNode(r);
        }), t.optimizeImages ? this.optimizeImages(s, t.optimizeImages) : s;
      }

      return console.warn("The render method must receive an Object with a \"content\" field.\n\t\t\tThe \"content\" field must be an array of nodes as the type ISbRichtext.\n\t\t\tISbRichtext:\n\t\t\t\tcontent?: ISbRichtext[]\n\t\t\t\tmarks?: ISbRichtext[]\n\t\t\t\tattrs?: any\n\t\t\t\ttext?: string\n\t\t\t\ttype: string\n\t\t\t\t\n\t\t\t\tExample:\n\t\t\t\t{\n\t\t\t\t\tcontent: [\n\t\t\t\t\t\t{\n\t\t\t\t\t\t\tcontent: [\n\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\ttext: 'Hello World',\n\t\t\t\t\t\t\t\t\ttype: 'text'\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t],\n\t\t\t\t\t\t\ttype: 'paragraph'\n\t\t\t\t\t\t}\n\t\t\t\t\t],\n\t\t\t\t\ttype: 'doc'\n\t\t\t\t}"), "";
    }
  }, {
    key: "optimizeImages",
    value: function optimizeImages(e, t) {
      var s = 0,
          r = 0,
          i = "",
          o = "";
      typeof t != "boolean" && (typeof t.width == "number" && t.width > 0 && (i += "width=\"".concat(t.width, "\" "), s = t.width), typeof t.height == "number" && t.height > 0 && (i += "height=\"".concat(t.height, "\" "), r = t.height), (t.loading === "lazy" || t.loading === "eager") && (i += "loading=\"".concat(t.loading, "\" ")), typeof t.class == "string" && t.class.length > 0 && (i += "class=\"".concat(t.class, "\" ")), t.filters && (typeof t.filters.blur == "number" && t.filters.blur >= 0 && t.filters.blur <= 100 && (o += ":blur(".concat(t.filters.blur, ")")), typeof t.filters.brightness == "number" && t.filters.brightness >= -100 && t.filters.brightness <= 100 && (o += ":brightness(".concat(t.filters.brightness, ")")), t.filters.fill && (t.filters.fill.match(/[0-9A-Fa-f]{6}/g) || t.filters.fill === "transparent") && (o += ":fill(".concat(t.filters.fill, ")")), t.filters.format && ["webp", "png", "jpeg"].includes(t.filters.format) && (o += ":format(".concat(t.filters.format, ")")), typeof t.filters.grayscale == "boolean" && t.filters.grayscale && (o += ":grayscale()"), typeof t.filters.quality == "number" && t.filters.quality >= 0 && t.filters.quality <= 100 && (o += ":quality(".concat(t.filters.quality, ")")), t.filters.rotate && [90, 180, 270].includes(t.filters.rotate) && (o += ":rotate(".concat(t.filters.rotate, ")")), o.length > 0 && (o = "/filters" + o))), i.length > 0 && (e = e.replace(/<img/g, "<img ".concat(i.trim())));
      var l = s > 0 || r > 0 || o.length > 0 ? "".concat(s, "x").concat(r).concat(o) : "";
      return e = e.replace(/a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|tiff|bmp)/g, "a.storyblok.com/f/$1/$2.$3/m/".concat(l)), typeof t != "boolean" && (t.sizes || t.srcset) && (e = e.replace(/<img.*?src=["|'](.*?)["|']/g, function (a) {
        var c, u;
        var p = a.match(/a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|tiff|bmp)/g);

        if (p && p.length > 0) {
          var d = {
            srcset: (c = t.srcset) == null ? void 0 : c.map(function (g) {
              if (typeof g == "number") return "//".concat(p, "/m/").concat(g, "x0").concat(o, " ").concat(g, "w");

              if (typeof g == "object" && g.length === 2) {
                var k = 0,
                    T = 0;
                return typeof g[0] == "number" && (k = g[0]), typeof g[1] == "number" && (T = g[1]), "//".concat(p, "/m/").concat(k, "x").concat(T).concat(o, " ").concat(k, "w");
              }
            }).join(", "),
            sizes: (u = t.sizes) == null ? void 0 : u.map(function (g) {
              return g;
            }).join(", ")
          };
          var f = "";
          return d.srcset && (f += "srcset=\"".concat(d.srcset, "\" ")), d.sizes && (f += "sizes=\"".concat(d.sizes, "\" ")), a.replace(/<img/g, "<img ".concat(f.trim()));
        }

        return a;
      })), e;
    }
  }, {
    key: "renderNode",
    value: function renderNode(e) {
      var _this3 = this;

      var t = [];
      e.marks && e.marks.forEach(function (r) {
        var i = _this3.getMatchingMark(r);

        i && i.tag !== "" && t.push(_this3.renderOpeningTag(i.tag));
      });
      var s = this.getMatchingNode(e);
      return s && s.tag && t.push(this.renderOpeningTag(s.tag)), e.content ? e.content.forEach(function (r) {
        t.push(_this3.renderNode(r));
      }) : e.text ? t.push(ae(e.text)) : s && s.singleTag ? t.push(this.renderTag(s.singleTag, " /")) : s && s.html ? t.push(s.html) : e.type === "emoji" && t.push(this.renderEmoji(e)), s && s.tag && t.push(this.renderClosingTag(s.tag)), e.marks && e.marks.slice(0).reverse().forEach(function (r) {
        var i = _this3.getMatchingMark(r);

        i && i.tag !== "" && t.push(_this3.renderClosingTag(i.tag));
      }), t.join("");
    }
  }, {
    key: "renderTag",
    value: function renderTag(e, t) {
      return e.constructor === String ? "<".concat(e).concat(t, ">") : e.map(function (s) {
        if (s.constructor === String) return "<".concat(s).concat(t, ">");
        {
          var r = "<".concat(s.tag);
          if (s.attrs) for (var i in s.attrs) {
            var o = s.attrs[i];
            o !== null && (r += " ".concat(i, "=\"").concat(o, "\""));
          }
          return "".concat(r).concat(t, ">");
        }
      }).join("");
    }
  }, {
    key: "renderOpeningTag",
    value: function renderOpeningTag(e) {
      return this.renderTag(e, "");
    }
  }, {
    key: "renderClosingTag",
    value: function renderClosingTag(e) {
      return e.constructor === String ? "</".concat(e, ">") : e.slice(0).reverse().map(function (t) {
        return t.constructor === String ? "</".concat(t, ">") : "</".concat(t.tag, ">");
      }).join("");
    }
  }, {
    key: "getMatchingNode",
    value: function getMatchingNode(e) {
      var t = this.nodes[e.type];
      if (typeof t == "function") return t(e);
    }
  }, {
    key: "getMatchingMark",
    value: function getMatchingMark(e) {
      var t = this.marks[e.type];
      if (typeof t == "function") return t(e);
    }
  }, {
    key: "renderEmoji",
    value: function renderEmoji(e) {
      if (e.attrs.emoji) return e.attrs.emoji;
      var t = [{
        tag: "img",
        attrs: {
          src: e.attrs.fallbackImage,
          draggable: "false",
          loading: "lazy",
          align: "absmiddle"
        }
      }];
      return this.renderTag(t, " /");
    }
  }]);

  return v;
}();

var le = /*#__PURE__*/function () {
  function le(e) {
    _classCallCheck(this, le);

    h(this, "baseURL"), h(this, "timeout"), h(this, "headers"), h(this, "responseInterceptor"), h(this, "fetch"), h(this, "ejectInterceptor"), h(this, "url"), h(this, "parameters"), h(this, "fetchOptions"), this.baseURL = e.baseURL, this.headers = e.headers || new Headers(), this.timeout = e != null && e.timeout ? e.timeout * 1e3 : 0, this.responseInterceptor = e.responseInterceptor, this.fetch = function () {
      return e.fetch ? e.fetch.apply(e, arguments) : fetch.apply(void 0, arguments);
    }, this.ejectInterceptor = !1, this.url = "", this.parameters = {}, this.fetchOptions = {};
  }
  /**
   *
   * @param url string
   * @param params ISbStoriesParams
   * @returns Promise<ISbResponse | Error>
   */


  _createClass(le, [{
    key: "get",
    value: function get(e, t) {
      return this.url = e, this.parameters = t, this._methodHandler("get");
    }
  }, {
    key: "post",
    value: function post(e, t) {
      return this.url = e, this.parameters = t, this._methodHandler("post");
    }
  }, {
    key: "put",
    value: function put(e, t) {
      return this.url = e, this.parameters = t, this._methodHandler("put");
    }
  }, {
    key: "delete",
    value: function _delete(e, t) {
      return this.url = e, this.parameters = t, this._methodHandler("delete");
    }
  }, {
    key: "_responseHandler",
    value: function () {
      var _responseHandler2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var t, s, _iterator, _step, r;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = [], s = {
                  data: {},
                  headers: {},
                  status: 0,
                  statusText: ""
                };
                _context2.t0 = e.status !== 204;

                if (!_context2.t0) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return e.json().then(function (r) {
                  s.data = r;
                });

              case 5:
                _iterator = _createForOfIteratorHelper(e.headers.entries());

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    r = _step.value;
                    t[r[0]] = r[1];
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                return _context2.abrupt("return", (s.headers = _objectSpread({}, t), s.status = e.status, s.statusText = e.statusText, s));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function _responseHandler(_x3) {
        return _responseHandler2.apply(this, arguments);
      }

      return _responseHandler;
    }()
  }, {
    key: "_methodHandler",
    value: function () {
      var _methodHandler2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        var t, s, a, r, i, o, l, c;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = "".concat(this.baseURL).concat(this.url), s = null;

                if (e === "get") {
                  a = new b();
                  t = "".concat(this.baseURL).concat(this.url, "?").concat(a.stringify(this.parameters));
                } else s = JSON.stringify(this.parameters);

                r = new URL(t), i = new AbortController(), o = i.signal;
                this.timeout && (l = setTimeout(function () {
                  return i.abort();
                }, this.timeout));
                _context3.prev = 4;
                _context3.next = 7;
                return this.fetch("".concat(r), _objectSpread({
                  method: e,
                  headers: this.headers,
                  body: s,
                  signal: o
                }, this.fetchOptions));

              case 7:
                a = _context3.sent;
                this.timeout && clearTimeout(l);
                _context3.next = 11;
                return this._responseHandler(a);

              case 11:
                c = _context3.sent;
                return _context3.abrupt("return", this.responseInterceptor && !this.ejectInterceptor ? this._statusHandler(this.responseInterceptor(c)) : this._statusHandler(c));

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](4);
                return _context3.abrupt("return", {
                  message: _context3.t0
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 15]]);
      }));

      function _methodHandler(_x4) {
        return _methodHandler2.apply(this, arguments);
      }

      return _methodHandler;
    }()
  }, {
    key: "setFetchOptions",
    value: function setFetchOptions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      Object.keys(e).length > 0 && "method" in e && delete e.method, this.fetchOptions = _objectSpread({}, e);
    }
  }, {
    key: "eject",
    value: function eject() {
      this.ejectInterceptor = !0;
    }
  }, {
    key: "_statusHandler",
    value: function _statusHandler(e) {
      var t = /20[0-6]/g;
      return new Promise(function (s, r) {
        if (t.test("".concat(e.status))) return s(e);
        var i = {
          message: e.statusText,
          status: e.status,
          response: Array.isArray(e.data) ? e.data[0] : e.data.error || e.data.slug
        };
        r(i);
      });
    }
  }]);

  return le;
}();

var S = "SB-Agent",
    w = {
  defaultAgentName: "SB-JS-CLIENT",
  defaultAgentVersion: "SB-Agent-Version",
  packageVersion: "6.0.0"
};
var y = {};
var m = {};

var ce = /*#__PURE__*/function () {
  /**
   *
   * @param config ISbConfig interface
   * @param endpoint string, optional
   */
  function ce(e, t) {
    _classCallCheck(this, ce);

    h(this, "client"), h(this, "maxRetries"), h(this, "throttle"), h(this, "accessToken"), h(this, "cache"), h(this, "helpers"), h(this, "resolveCounter"), h(this, "relations"), h(this, "links"), h(this, "richTextResolver"), h(this, "resolveNestedRelations"), h(this, "stringifiedStoriesCache");
    var s = e.endpoint || t;

    if (!s) {
      var o = new b().getRegionURL,
          l = e.https === !1 ? "http" : "https";
      e.oauthToken ? s = "".concat(l, "://").concat(o(e.region), "/v1") : s = "".concat(l, "://").concat(o(e.region), "/v2");
    }

    var r = new Headers();
    if (r.set("Content-Type", "application/json"), r.set("Accept", "application/json"), e.headers) for (var _o in e.headers) {
      r.set(_o, e.headers[_o]);
    }
    r.has(S) || (r.set(S, w.defaultAgentName), r.set(w.defaultAgentVersion, w.packageVersion));
    var i = 5;
    e.oauthToken && (r.set("Authorization", e.oauthToken), i = 3), e.rateLimit && (i = e.rateLimit), e.richTextSchema ? this.richTextResolver = new v(e.richTextSchema) : this.richTextResolver = new v(), e.componentResolver && this.setComponentResolver(e.componentResolver), this.maxRetries = e.maxRetries || 5, this.throttle = C(this.throttledRequest, i, 1e3), this.accessToken = e.accessToken || "", this.relations = {}, this.links = {}, this.cache = e.cache || {
      clear: "manual"
    }, this.helpers = new b(), this.resolveCounter = 0, this.resolveNestedRelations = e.resolveNestedRelations || !0, this.stringifiedStoriesCache = {}, this.client = new le({
      baseURL: s,
      timeout: e.timeout || 0,
      headers: r,
      responseInterceptor: e.responseInterceptor,
      fetch: e.fetch
    });
  }

  _createClass(ce, [{
    key: "setComponentResolver",
    value: function setComponentResolver(e) {
      this.richTextResolver.addNode("blok", function (t) {
        var s = "";
        return t.attrs.body && t.attrs.body.forEach(function (r) {
          s += e(r.component, r);
        }), {
          html: s
        };
      });
    }
  }, {
    key: "parseParams",
    value: function parseParams(e) {
      return e.token || (e.token = this.getToken()), e.cv || (e.cv = m[e.token]), Array.isArray(e.resolve_relations) && (e.resolve_relations = e.resolve_relations.join(",")), typeof e.resolve_relations < "u" && (e.resolve_level = 2), e;
    }
  }, {
    key: "factoryParamOptions",
    value: function factoryParamOptions(e, t) {
      return this.helpers.isCDNUrl(e) ? this.parseParams(t) : t;
    }
  }, {
    key: "makeRequest",
    value: function makeRequest(e, t, s, r) {
      var i = this.factoryParamOptions(e, this.helpers.getOptionsPage(t, s, r));
      return this.cacheResponse(e, i);
    }
  }, {
    key: "get",
    value: function get(e, t, s) {
      t || (t = {});
      var r = "/".concat(e),
          i = this.factoryParamOptions(r, t);
      return this.client.setFetchOptions(s), this.cacheResponse(r, i);
    }
  }, {
    key: "getAll",
    value: function () {
      var _getAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, t, s, r) {
        var _this4 = this;

        var i, o, l, a, c, u, p, d;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                i = (t == null ? void 0 : t.per_page) || 25;
                o = "/".concat(e);
                l = o.split("/");
                a = s || l[l.length - 1];
                c = 1;
                _context4.next = 7;
                return this.makeRequest(o, t, i, c);

              case 7:
                u = _context4.sent;
                p = u.total ? Math.ceil(u.total / i) : 1;
                this.client.setFetchOptions(r);
                _context4.next = 12;
                return this.helpers.asyncMap(this.helpers.range(c, p), function (f) {
                  return _this4.makeRequest(o, t, i, f + 1);
                });

              case 12:
                d = _context4.sent;
                return _context4.abrupt("return", this.helpers.flatMap([u].concat(_toConsumableArray(d)), function (f) {
                  return Object.values(f.data[a]);
                }));

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAll(_x5, _x6, _x7, _x8) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "post",
    value: function post(e, t, s) {
      var r = "/".concat(e);
      return this.client.setFetchOptions(s), Promise.resolve(this.throttle("post", r, t));
    }
  }, {
    key: "put",
    value: function put(e, t, s) {
      var r = "/".concat(e);
      return this.client.setFetchOptions(s), Promise.resolve(this.throttle("put", r, t));
    }
  }, {
    key: "delete",
    value: function _delete(e, t, s) {
      var r = "/".concat(e);
      return this.client.setFetchOptions(s), Promise.resolve(this.throttle("delete", r, t));
    }
  }, {
    key: "getStories",
    value: function getStories(e, t) {
      return this.client.setFetchOptions(t), this._addResolveLevel(e), this.get("cdn/stories", e);
    }
  }, {
    key: "getStory",
    value: function getStory(e, t, s) {
      return this.client.setFetchOptions(s), this._addResolveLevel(t), this.get("cdn/stories/".concat(e), t);
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return this.accessToken;
    }
  }, {
    key: "ejectInterceptor",
    value: function ejectInterceptor() {
      this.client.eject();
    }
  }, {
    key: "_addResolveLevel",
    value: function _addResolveLevel(e) {
      typeof e.resolve_relations < "u" && (e.resolve_level = 2);
    }
  }, {
    key: "_cleanCopy",
    value: function _cleanCopy(e) {
      return JSON.parse(JSON.stringify(e));
    }
  }, {
    key: "_insertLinks",
    value: function _insertLinks(e, t, s) {
      var r = e[t];
      r && r.fieldtype == "multilink" && r.linktype == "story" && typeof r.id == "string" && this.links[s][r.id] ? r.story = this._cleanCopy(this.links[s][r.id]) : r && r.linktype === "story" && typeof r.uuid == "string" && this.links[s][r.uuid] && (r.story = this._cleanCopy(this.links[s][r.uuid]));
    }
    /**
     *
     * @param resolveId A counter number as a string
     * @param uuid The uuid of the story
     * @returns string | object
     */

  }, {
    key: "getStoryReference",
    value: function getStoryReference(e, t) {
      return this.relations[e][t] ? (this.stringifiedStoriesCache[t] || (this.stringifiedStoriesCache[t] = JSON.stringify(this.relations[e][t])), JSON.parse(this.stringifiedStoriesCache[t])) : t;
    }
  }, {
    key: "_insertRelations",
    value: function _insertRelations(e, t, s, r) {
      var _this5 = this;

      s.indexOf("".concat(e.component, ".").concat(t)) > -1 && (typeof e[t] == "string" ? e[t] = this.getStoryReference(r, e[t]) : Array.isArray(e[t]) && (e[t] = e[t].map(function (i) {
        return _this5.getStoryReference(r, i);
      }).filter(Boolean)));
    }
  }, {
    key: "iterateTree",
    value: function iterateTree(e, t, s) {
      var _this6 = this;

      var r = function r(i) {
        if (i != null) {
          if (i.constructor === Array) for (var o = 0; o < i.length; o++) {
            r(i[o]);
          } else if (i.constructor === Object) {
            if (i._stopResolving) return;

            for (var _o2 in i) {
              (i.component && i._uid || i.type === "link") && (_this6._insertRelations(i, _o2, t, s), _this6._insertLinks(i, _o2, s)), r(i[_o2]);
            }
          }
        }
      };

      r(e.content);
    }
  }, {
    key: "resolveLinks",
    value: function () {
      var _resolveLinks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, t, s) {
        var _this7 = this;

        var r, i, o, l, a, c, _a;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                r = [];

                if (!e.link_uuids) {
                  _context5.next = 14;
                  break;
                }

                i = e.link_uuids.length, o = [], l = 50;

                for (a = 0; a < i; a += l) {
                  c = Math.min(i, a + l);
                  o.push(e.link_uuids.slice(a, c));
                }

                _a = 0;

              case 5:
                if (!(_a < o.length)) {
                  _context5.next = 12;
                  break;
                }

                _context5.next = 8;
                return this.getStories({
                  per_page: l,
                  language: t.language,
                  version: t.version,
                  by_uuids: o[_a].join(",")
                });

              case 8:
                _context5.sent.data.stories.forEach(function (c) {
                  r.push(c);
                });

              case 9:
                _a++;
                _context5.next = 5;
                break;

              case 12:
                _context5.next = 15;
                break;

              case 14:
                r = e.links;

              case 15:
                r.forEach(function (i) {
                  _this7.links[s][i.uuid] = _objectSpread(_objectSpread({}, i), {}, {
                    _stopResolving: !0
                  });
                });

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function resolveLinks(_x9, _x10, _x11) {
        return _resolveLinks.apply(this, arguments);
      }

      return resolveLinks;
    }()
  }, {
    key: "resolveRelations",
    value: function () {
      var _resolveRelations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e, t, s) {
        var _this8 = this;

        var r, i, o, l, a, c, _a2;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                r = [];

                if (!e.rel_uuids) {
                  _context6.next = 14;
                  break;
                }

                i = e.rel_uuids.length, o = [], l = 50;

                for (a = 0; a < i; a += l) {
                  c = Math.min(i, a + l);
                  o.push(e.rel_uuids.slice(a, c));
                }

                _a2 = 0;

              case 5:
                if (!(_a2 < o.length)) {
                  _context6.next = 12;
                  break;
                }

                _context6.next = 8;
                return this.getStories({
                  per_page: l,
                  language: t.language,
                  version: t.version,
                  by_uuids: o[_a2].join(","),
                  excluding_fields: t.excluding_fields
                });

              case 8:
                _context6.sent.data.stories.forEach(function (c) {
                  r.push(c);
                });

              case 9:
                _a2++;
                _context6.next = 5;
                break;

              case 12:
                _context6.next = 15;
                break;

              case 14:
                r = e.rels;

              case 15:
                r && r.length > 0 && r.forEach(function (i) {
                  _this8.relations[s][i.uuid] = _objectSpread(_objectSpread({}, i), {}, {
                    _stopResolving: !0
                  });
                });

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function resolveRelations(_x12, _x13, _x14) {
        return _resolveRelations.apply(this, arguments);
      }

      return resolveRelations;
    }()
    /**
     *
     * @param responseData
     * @param params
     * @param resolveId
     * @description Resolves the relations and links of the stories
     * @returns Promise<void>
     *
     */

  }, {
    key: "resolveStories",
    value: function () {
      var _resolveStories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e, t, s) {
        var _this9 = this;

        var r, i, o, l;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                o = [];
                this.links[s] = {};
                this.relations[s] = {};
                _context7.t0 = typeof t.resolve_relations < "u" && t.resolve_relations.length > 0;

                if (!_context7.t0) {
                  _context7.next = 8;
                  break;
                }

                typeof t.resolve_relations == "string" && (o = t.resolve_relations.split(","));
                _context7.next = 8;
                return this.resolveRelations(e, t, s);

              case 8:
                _context7.t1 = t.resolve_links && ["1", "story", "url", "link"].indexOf(t.resolve_links) > -1 && ((r = e.links) != null && r.length || (i = e.link_uuids) != null && i.length);

                if (!_context7.t1) {
                  _context7.next = 12;
                  break;
                }

                _context7.next = 12;
                return this.resolveLinks(e, t, s);

              case 12:
                if (!this.resolveNestedRelations) {
                  _context7.next = 14;
                  break;
                }

                for (l in this.relations[s]) {
                  this.iterateTree(this.relations[s][l], o, s);
                }

              case 14:
                e.story ? this.iterateTree(e.story, o, s) : e.stories.forEach(function (l) {
                  _this9.iterateTree(l, o, s);
                }), this.stringifiedStoriesCache = {}, delete this.links[s], delete this.relations[s];

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function resolveStories(_x15, _x16, _x17) {
        return _resolveStories.apply(this, arguments);
      }

      return resolveStories;
    }()
  }, {
    key: "cacheResponse",
    value: function () {
      var _cacheResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e, t, s) {
        var _this10 = this;

        var r, i, o;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                (typeof s > "u" || !s) && (s = 0);
                r = this.helpers.stringify({
                  url: e,
                  params: t
                }), i = this.cacheProvider();
                _context9.t0 = this.cache.clear === "auto" && t.version === "draft";

                if (!_context9.t0) {
                  _context9.next = 6;
                  break;
                }

                _context9.next = 6;
                return this.flushCache();

              case 6:
                if (!(t.version === "published" && e != "/cdn/spaces/me")) {
                  _context9.next = 12;
                  break;
                }

                _context9.next = 9;
                return i.get(r);

              case 9:
                o = _context9.sent;

                if (!o) {
                  _context9.next = 12;
                  break;
                }

                return _context9.abrupt("return", Promise.resolve(o));

              case 12:
                return _context9.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(o, l) {
                    var a, c, u, p;
                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _context8.prev = 0;
                            _context8.next = 3;
                            return _this10.throttle("get", e, t);

                          case 3:
                            c = _context8.sent;

                            if (!(c.status !== 200)) {
                              _context8.next = 6;
                              break;
                            }

                            return _context8.abrupt("return", l(c));

                          case 6:
                            u = {
                              data: c.data,
                              headers: c.headers
                            };

                            if (!((a = c.headers) != null && a["per-page"] && (u = Object.assign({}, u, {
                              perPage: c.headers["per-page"] ? parseInt(c.headers["per-page"]) : 0,
                              total: c.headers["per-page"] ? parseInt(c.headers.total) : 0
                            })), u.data.story || u.data.stories)) {
                              _context8.next = 11;
                              break;
                            }

                            p = _this10.resolveCounter = ++_this10.resolveCounter % 1e3;
                            _context8.next = 11;
                            return _this10.resolveStories(u.data, t, "".concat(p));

                          case 11:
                            _context8.t0 = t.version === "published" && e != "/cdn/spaces/me";

                            if (!_context8.t0) {
                              _context8.next = 15;
                              break;
                            }

                            _context8.next = 15;
                            return i.set(r, u);

                          case 15:
                            _context8.t1 = u.data.cv && t.token;

                            if (!_context8.t1) {
                              _context8.next = 22;
                              break;
                            }

                            _context8.t2 = t.version === "draft" && m[t.token] != u.data.cv;

                            if (!_context8.t2) {
                              _context8.next = 21;
                              break;
                            }

                            _context8.next = 21;
                            return _this10.flushCache();

                          case 21:
                            m[t.token] = t.cv ? t.cv : u.data.cv;

                          case 22:
                            return _context8.abrupt("return", o(u));

                          case 25:
                            _context8.prev = 25;
                            _context8.t3 = _context8["catch"](0);

                            if (!(_context8.t3.response && _context8.t3.status === 429 && (s = s ? s + 1 : 0, s < _this10.maxRetries))) {
                              _context8.next = 32;
                              break;
                            }

                            console.log("Hit rate limit. Retrying in ".concat(s, " seconds."));
                            _context8.next = 31;
                            return _this10.helpers.delay(1e3 * s);

                          case 31:
                            return _context8.abrupt("return", _this10.cacheResponse(e, t, s).then(o).catch(l));

                          case 32:
                            l(_context8.t3);

                          case 33:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8, null, [[0, 25]]);
                  }));

                  return function (_x21, _x22) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function cacheResponse(_x18, _x19, _x20) {
        return _cacheResponse.apply(this, arguments);
      }

      return cacheResponse;
    }()
  }, {
    key: "throttledRequest",
    value: function throttledRequest(e, t, s) {
      return this.client[e](t, s);
    }
  }, {
    key: "cacheVersions",
    value: function cacheVersions() {
      return m;
    }
  }, {
    key: "cacheVersion",
    value: function cacheVersion() {
      return m[this.accessToken];
    }
  }, {
    key: "setCacheVersion",
    value: function setCacheVersion(e) {
      this.accessToken && (m[this.accessToken] = e);
    }
  }, {
    key: "clearCacheVersion",
    value: function clearCacheVersion() {
      this.accessToken && (m[this.accessToken] = 0);
    }
  }, {
    key: "cacheProvider",
    value: function cacheProvider() {
      switch (this.cache.type) {
        case "memory":
          return {
            get: function get(e) {
              return Promise.resolve(y[e]);
            },
            getAll: function getAll() {
              return Promise.resolve(y);
            },
            set: function set(e, t) {
              return y[e] = t, Promise.resolve(void 0);
            },
            flush: function flush() {
              return y = {}, Promise.resolve(void 0);
            }
          };

        case "custom":
          if (this.cache.custom) return this.cache.custom;

        default:
          return {
            get: function get() {
              return Promise.resolve();
            },
            getAll: function getAll() {
              return Promise.resolve(void 0);
            },
            set: function set() {
              return Promise.resolve(void 0);
            },
            flush: function flush() {
              return Promise.resolve(void 0);
            }
          };
      }
    }
  }, {
    key: "flushCache",
    value: function () {
      var _flushCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.cacheProvider().flush();

              case 2:
                this.clearCacheVersion();
                return _context10.abrupt("return", this);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function flushCache() {
        return _flushCache.apply(this, arguments);
      }

      return flushCache;
    }()
  }]);

  return ce;
}();

var ue = function ue() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var e = n.apiOptions;

  if (!e.accessToken) {
    console.error("You need to provide an access token to interact with Storyblok API. Read https://www.storyblok.com/docs/api/content-delivery#topics/authentication");
    return;
  }

  return {
    storyblokApi: new ce(e)
  };
},
    pe = function pe(n) {
  if (typeof n != "object" || typeof n._editable > "u") return {};

  try {
    var e = JSON.parse(n._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, ""));
    return e ? {
      "data-blok-c": JSON.stringify(e),
      "data-blok-uid": e.id + "-" + e.uid
    } : {};
  } catch (_unused) {
    return {};
  }
};

var R,
    $ = "https://app.storyblok.com/f/storyblok-v2-latest.js";

var ge = function ge(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var s;
  var r = !(typeof window > "u") && typeof window.storyblokRegisterEvent < "u",
      i = +new URL((s = window.location) == null ? void 0 : s.href).searchParams.get("_storyblok") === n;

  if (!(!r || !i)) {
    if (!n) {
      console.warn("Story ID is not defined. Please provide a valid ID.");
      return;
    }

    window.storyblokRegisterEvent(function () {
      new window.StoryblokBridge(t).on(["input", "published", "change"], function (o) {
        o.action === "input" && o.story.id === n ? e(o.story) : (o.action === "change" || o.action === "published") && o.storyId === n && window.location.reload();
      });
    });
  }
},
    de = function de() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var e, t;
  var s = n.bridge,
      r = n.accessToken,
      _n$use = n.use,
      i = _n$use === void 0 ? [] : _n$use,
      _n$apiOptions = n.apiOptions,
      o = _n$apiOptions === void 0 ? {} : _n$apiOptions,
      _n$richText = n.richText,
      l = _n$richText === void 0 ? {} : _n$richText,
      a = n.bridgeUrl;
  o.accessToken = o.accessToken || r;
  var c = {
    bridge: s,
    apiOptions: o
  };
  var u = {};
  i.forEach(function (d) {
    u = _objectSpread(_objectSpread({}, u), d(c));
  }), a && ($ = a);
  var p = !(typeof window > "u") && ((t = (e = window.location) == null ? void 0 : e.search) == null ? void 0 : t.includes("_storyblok_tk"));
  return s !== !1 && p && O($), R = new v(l.schema), l.resolver && E(R, l.resolver), u;
},
    E = function E(n, e) {
  n.addNode("blok", function (t) {
    var s = "";
    return t.attrs.body.forEach(function (r) {
      s += e(r.component, r);
    }), {
      html: s
    };
  });
},
    he = function he(n) {
  return !n || !(n != null && n.content.some(function (e) {
    return e.content || e.type === "blok" || e.type === "horizontal_rule";
  }));
},
    fe = function fe(n, e, t) {
  var s = t || R;

  if (!s) {
    console.error("Please initialize the Storyblok SDK before calling the renderRichText function");
    return;
  }

  return he(n) ? "" : (e && (s = new v(e.schema), e.resolver && E(s, e.resolver)), s.render(n));
},
    me = function me() {
  return O($);
};

export { v as RichTextResolver, ne as RichTextSchema, ue as apiPlugin, he as isRichTextEmpty, me as loadStoryblokBridge, ge as registerStoryblokBridge, fe as renderRichText, pe as storyblokEditable, de as storyblokInit, ge as useStoryblokBridge };